import type { ComponentProps } from 'react';
import { cn } from '@/lib/cn.ts';

/**
 * A loading placeholder shaped like the content that will replace it.
 *
 * Shaped, not generic: a skeleton whose layout matches the eventual table means the page does not
 * reflow when data lands, which is the whole reason to prefer one over the word "Loading".
 */
export function Skeleton({ className, ...props }: ComponentProps<'div'>) {
  return <div className={cn('bg-muted animate-pulse rounded-md', className)} {...props} />;
}
